<template>
  <div class="vue-wrapper-full" style="flex-wrap: wrap">

    <div class="content-container flex-row">
      <!-- Sidebar -->
      <div class="sidebar white left fixed" :class="sidebarVisibleClass">
        <div class="fixed-container">
          <a href="javascript:;" @click="toggleSidebar" class="sidebar-minimized-button table-overlay-close">
            <span class="button-arrow"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-small"></use></svg></span>
            <span class="glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg></span>
          </a>

          <div class="sidebar-content-container small-padding custom-scrollbar">
            <TheSidebarModule
              v-if="auction && selected"
              v-on:on-save="onSave"
              v-on:on-delete="onDelete"
              :used="usedSpadeNr"
              :item="selected"
            />
            <TheEmptyList v-else :title="'Velg auksjonskode og klikk søk.'" :message="'Velg deretter spade i listen som du ønsker redigere.'" :large="false" :icon="'button-glyph-object'"/>
          </div>
        </div>
      </div>
      <!-- // Sidebar -->

      <!-- Objekt list -->
      <div class="content-container flex-row">
        <div class="content-container flex-column">
          <TheLoader :active="updating" :update="true" :small="true"/>

          <a v-if="auction && !(updating || loading)" @click="setSelected('new')" class="button action fixed right">Ny spade</a>

          <div id="scroll-container" class="content-container gray flex-row content-x-scroll content-y-scroll small-toolbar">
            <!-- Pagination -->
            <div class="pagination-loader-container">
              <div class="pagination-loader">
                <span class="results">Viser <strong>{{list.length | thousands}}</strong> av {{hits | thousands}} treff</span>

                <!-- <a href="javascript:;" v-if="loading" class="button primary tiny loading">Last flere <span class="loader-spinner"></span></a>
                <a href="javascript:;" v-else-if="list.length < 1" class="button primary tiny disabled">Last flere</a>
                <a href="javascript:;" v-else-if="list.length < hits" @click="more()" class="button primary tiny">Last flere</a>
                <a href="javascript:;" v-else-if="list.length >= hits" class="button primary tiny disabled">Last flere</a> -->

                <a href="javascript:;" @click="scrollToTop()" title="Scroll til toppen" class="button tiny scrolltop"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
              </div>
            </div>
            <!-- // Pagination -->

            <table class="large fixed sortable clickable sticky-table-header compressed color-rows c-image-none" style="height: 0">
              <thead>
                <tr class="header">
                  <th v-for="(col, index) in columns" :key="col.key + '_' + index" class="handle" :class="col.class" @click="sortColumn(col, index)">
                    {{col.name}}
                    <span id="sorttable_sortfwdind" v-if="sort === col.sortKey && dir === 'ASC'" class="sort-on">&nbsp;</span>
                    <span id="sorttable_sortrevind" v-else-if="sort === col.sortKey && dir === 'DESC'" class="sort-on">&nbsp;</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, trindex) in list" :key="trindex" :class="{'color-row-active': hasSelected(row.Spadeid)}" @click="setSelected(row.Spadeid)">
                  <template v-for="(col, tdindex) in row.row">
                    <td :key="trindex + '.' + tdindex" :class="col.class" >{{col.value}}</td>
                  </template>
                </tr>
                <template v-if="searchDone">
                  <tr v-if="list.length < 1"><td colspan="30" style="text-align: left;">Fant ingen spader...</td></tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- // Objekt list -->
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import AuksjonService from '@/services/AuksjonService'
import TheSidebarModule from './TheSidebarModule'

export default {
  name: 'Spader',
  components: {
    TheSidebarModule
  },
  data () {
    return {
      showSidebar: false,
      updating: false,
      loading: false,
      auction: null,
      code: null,
      hits: 0,
      page: 1,
      last: null,
      list: [],
      info: {},
      selected: null,
      searchDone: false,
      sort: 'Spadenr',
      dir: 'ASC'
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Spader'
    },
    columns: function () {
      return this.$store.getters['spader/columns']
    },
    sidebarVisibleClass: function () {
      return this.showSidebar ? 'minimizable' : 'minimized'
    },
    usedSpadeNr: function () {
      return this.list.map(i => i.Spadenr) || []
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')

    this.showSidebar = localStorage.getItem('spader-sidebar')

    bus.$off('spader-reset')
    bus.$off('spader-start')
    bus.$off('spader-export')
  },
  mounted () {
    bus.$on('spader-reset', () => this.onReset())
    bus.$on('spader-start', (data) => this.onSearch(data))
    bus.$on('spader-export', () => this.onExportResults())
  },
  methods: {
    onReset: function () {
      this.updating = false
      this.loading = false
      this.auction = null
      this.code = null
      this.hits = 0
      this.page = 1
      this.last = null
      this.list = []
      this.info = {}
      this.selected = null
      this.searchDone = false
      this.sort = 'Spadenr'
      this.dir = 'ASC'
    },
    onSave: function (data) {
      this.updating = true

      const queryParams = {
        page: this.page || 1,
        sort: this.sort || 'Spadenr',
        direction: this.dir || 'ASC'
      }

      const update = data._action && data._action === 'update'

      AuksjonService.getSpader(this.code, queryParams)
        .then(response => {
          this.rearrange(response.data.items)
            .then((parsed) => {
              this.list = parsed.list
              this.info = parsed.info
              this.hits = this.list.length

              if (update) {
                this.selected = {
                  idx: data.Spadeid,
                  obj: data
                }
              } else {
                this.setSelected('new')
              }
            })
        })
        .catch(error => {
          console.log('*** Search error, after save')
          const custom = this.$helpers.getCustomErrors(error)
          if (custom && custom.auction) {
            this.$helpers.showErrorAlert('Feil', 'Fant ikke auksjon: "' + this.code + '"')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen')
          }
        })
        .then(() => {
          this.updating = false
        })
    },
    onDelete: function (data) {
      const index = this.list.findIndex(i => i.Spadeid === data.Spadeid)

      if (index !== -1) {
        this.list.splice(index, 1)
        this.hits = this.list.length

        this.setSelected('new')
      }
    },
    setSelected: function (Spadeid) {
      if (Spadeid === null) {
        this.selected = null
      } else if (Spadeid === 'new') {
        this.selected = {
          idx: null,
          obj: {
            Auksjon: this.code
          }
        }
      } else if (!this.selected || this.selected.idx !== Spadeid) {
        const data = this.info.hasOwnProperty(Spadeid) ? this.info[Spadeid] : {}

        this.selected = {
          idx: Spadeid,
          obj: data
        }
      } else if (this.selected.idx === Spadeid) {
        this.selected = null
      }
    },
    hasSelected: function (Spadeid) {
      return this.selected && this.selected.idx === Spadeid
    },
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar

      if (this.showSidebar) {
        localStorage.setItem('spader-sidebar', 1)
      } else {
        localStorage.removeItem('spader-sidebar')
      }
    },
    scrollToTop: function () {
      window.jQuery('#scroll-container').scrollTop(0)
    },
    sortColumn: function (column, index) {
      if (!column.sortKey) {
        return
      }

      if (column.sortKey === this.sort) {
        this.dir = this.dir === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sort = column.sortKey
        this.dir = 'ASC'
      }

      this.search()
    },
    onAfterColumnUpdate: function () {
      this.rearrange(this.list)
    },
    onSearch: function (data) {
      this.code = data.code || null

      if (this.code) {
        this.search()
      }
    },
    search: function () {
      if (this.loading) {
        console.log('Already searching, so skip...')
        return
      }

      this.setSelected(null)
      this.searchDone = false
      this.auction = null
      this.loading = true

      const queryParams = {
        page: this.page || 1,
        sort: this.sort || 'Spadenr',
        direction: this.dir || 'ASC'
      }

      console.log('*** Search with:', this.code, queryParams)
      AuksjonService.getSpader(this.code, queryParams)
        .then(response => {
          this.auction = response.data.auction

          this.rearrange(response.data.items)
            .then((parsed) => {
              this.list = parsed.list
              this.info = parsed.info
              this.hits = this.list.length
            })
        })
        .catch(error => {
          console.log('*** Search error')

          // Reset on error
          this.list = []
          this.info = {}
          this.hits = 0

          const custom = this.$helpers.getCustomErrors(error)
          if (custom && custom.auction) {
            this.$helpers.showErrorAlert('Feil', 'Fant ikke auksjon: "' + this.code + '"')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen')
          }
        })
        .then(() => {
          this.loading = false
          this.searchDone = true
        })
    },
    rearrange: function (data) {
      return new Promise((resolve, reject) => {
        const retval = {
          list: [],
          info: {}
        }

        // Parse/format/sort data
        data.forEach(obj => {
          const row = []

          this.columns.forEach(c => {
            let val = this._.get(obj, c.key, c.default)
            let cls = c.class

            if (c.filter && val !== c.default) {
              switch (c.filter) {
                case 'date':
                  val = this.$options.filters.avantidate(val)
                  break
                case 'datetime':
                  val = this.$options.filters.avantidatetime(val)
                  break
                case 'integer':
                  val = this.$options.filters.thousands(val)
                  break
                case 'decimal':
                  val = this.$options.filters.thousandsFloat(val)
                  break
              }
            }

            row.push({ value: val, class: cls })
          })

          retval.info[obj.Spadeid] = obj
          retval.list.push({ Spadeid: obj.Spadeid, Spadenr: obj.Spadenr, row: row })
        })

        resolve(retval)
      })
    },
    onExportResults: function () {
      console.log('Noting to do, at least no yet anyways...')
      return true
    }
  }
}
</script>
<style scoped>
  table td:focus {
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Spader/Spader.vue